import { Button, styled } from "@mui/material";

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "varianttype",
})(({ theme, varianttype }) => {
  const variants = {
    default: {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },

    secondary: {
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.text.primary,
      "&:hover": {
        backgroundColor: theme.palette.grey[300],
      },
    },

    outline: {
      backgroundColor: "transparent",
      color: theme.palette.text.primary,
      border: `1px solid ${theme.palette.divider}`,
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    },

    destructive: {
      backgroundColor: theme.palette.error.main,
      color: "#fff",
      "&:hover": {
        backgroundColor: theme.palette.error.dark,
      },
    },
  };

  return {
    textTransform: "none",
    borderRadius: 4,
    padding: theme.spacing(1, 2),
    fontWeight: 500,
    boxShadow: "none",

    ...variants[varianttype || "default"],

    "&.Mui-disabled": {
      opacity: 0.5,
      color: theme.palette.text.disabled,
      backgroundColor:
        varianttype === "outline"
          ? "transparent"
          : theme.palette.action.disabledBackground,
      border:
        varianttype === "outline"
          ? `1px solid ${theme.palette.action.disabled}`
          : "none",
    },
  };
});

export const CustomButton = ({
  children,
  variantType = "default",
  isLoading,
  disabled,
  ...props
}) => {
  return (
    <StyledButton
      varianttype={variantType}
      disabled={disabled || isLoading}
      {...props}
    >
      {children}
    </StyledButton>
  );
};
